<template>
    <div class="row" >
        <div class="col-lg-12">
            <div style="max-width:85vw" class="mx-auto my-auto">
                <img src="/ComingSoon.jpg" class="d-block  img-fluid" />
            </div>
        </div>
    </div>
</template>